import { Injectable, ErrorHandler, Injector, NgZone } from '@angular/core';
import { HttpErrorResponse} from '@angular/common/http';
// import { ToastManagerService } from '../../services/toastmanager/toast-manager.service';
import { Router } from '@angular/router';

// Sentry.init({
//   dsn: 'https://971b99e9991f4bb4a0cac3f9d73ca244:547db10b3c804df9a7153a329a0fad9c@sentry.netrocks.info/4'
// });

@Injectable()
export class ErrorsService extends ErrorHandler {

  get router(): Router {
    return this.injector.get(Router);
  }
  constructor(private injector: Injector) {
    super();
   }

  handleError(error) {
    // const eventId = Sentry.captureException(error.originalError || error);
    // Sentry.showReportDialog({ eventId });
    if (error instanceof HttpErrorResponse) {
      // Handle Http Error
      if ( error.status === 400 ) {
        console.log('Handle 400!');
        return;
      }
      if ( error.status === 401) {
        console.log('Handle 401!');
        return error;
      }
      if (error.status === 404) {
        console.log('Handle 404!');
        // this.router.navigate(['./']);
        return;
      }
      if ( error.status === 500) {
        console.log('Handle 500!');
        // this.toastManager.showError('Server Error 500!');
        return;
      }
    }
    super.handleError(error);
  }
}
